import { render, staticRenderFns } from "./basic-data-group.vue?vue&type=template&id=3f529677"
import script from "./basic-data-group.vue?vue&type=script&lang=js"
export * from "./basic-data-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports